import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewPrimeiraVezInteresse from "../views/ViewPrimeiraVezInteresse";
import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";

const ContainerComponente = styled.div`
  display: grid;
  grid-template: 100px 120vh 30vh / auto;
  @media (min-height: 1000px) {
    grid-template: 100px 110vh 50vh / auto;
  }
  @media (min-height: 1200px) {
    grid-template: 100px 110vh 60vh / auto;
  }
  @media (max-width: 300px) {
    grid-template: 100px 120vh 50vh / auto;
  }
  @media (min-width: 1000px) {
    grid-template: 100px 120vh 50vh / auto;
  }
`;

const PrimeiraVezInteresse: React.FC = () => (
  <>
    <ContatoZap />
    <ContainerComponente>
      <ViewAppBar />
      <ViewPrimeiraVezInteresse />
      <ViewFooter />
    </ContainerComponente>
  </>
);
export default PrimeiraVezInteresse;
